<template>
    <div class="container-fluid signup-page">
      <div v-if="logoutSplash" class="logout-splash">
        <span>{{ logoutMessage }}</span>
      </div>
        <div class="container signup-layout">
            <aside class="signup-hero">
                <div class="signup-hero-badge">
                    <i class="fa fa-shield"></i>
                    Secure onboarding
                </div>
                <h2>Build a verified profile that looks premium from day one.</h2>
                <p>
                    Complete your account setup, verify your identity, and publish a polished profile designed to convert visitors into followers.
                </p>

                <div class="signup-benefits">
                    <div class="benefit-item">
                        <i class="fa fa-id-card-o"></i>
                        <div>
                            <strong>Identity verified</strong>
                            <span>Keep the platform safe and trusted.</span>
                        </div>
                    </div>
                    <div class="benefit-item">
                        <i class="fa fa-camera-retro"></i>
                        <div>
                            <strong>Profile ready</strong>
                            <span>Upload a clear photo and finish setup fast.</span>
                        </div>
                    </div>
                    <div class="benefit-item">
                        <i class="fa fa-bolt"></i>
                        <div>
                            <strong>Quick launch</strong>
                            <span>Get through signup in just a few minutes.</span>
                        </div>
                    </div>
                </div>
            </aside>
            <div class="signup-card">
                <h2>
                    Almost there!
                </h2>
                <p>
                    We just need a few details about you to help us setup your account.
                </p>
                
                <div class="signup-toggle">
                    <span class="personal-info">
                      <i class="fa fa-user"></i> Model Signup
                    </span>
                </div>
                <span v-if="personal_information">
                    <div class="row">
                        <label for=""> Account type</label>
                        <select name="" id="" class="form-control input-select" v-model="account_type" required>
                            <option value="">Select your account type</option>
                            <option value="escort">Escort Model(Escort services + premium content)</option>
                            <option value="content-creator">Content Creator(Premium content only)</option>
                        </select>
                    </div>
                    <div class="row">
                        <label for=""> Profile name</label>
                        <input type="text" class="form-control  input-text" v-model="profile_name" placeholder="Your profile name" required>
                    </div>
                    <div class="row">
                        <label for=""> Short slogan</label>
                        <input type="text" class="form-control input-text" v-model="slogan" placeholder="Enter your short slogan" required>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="profile_picture" class="form-label fw-semibold">
                                    Upload Profile Picture
                                </label>
                                <input
                                    type="file"
                                    class="form-control form-control-lg border-primary shadow-sm"
                                    id="profile_picture"
                                    @change="onFileChange"
                                    accept="image/*"
                                    :disabled="livenessVerified"
                                />
                                <div class="form-text text-white">
                                    Supported formats: JPG, PNG, GIF. Max size: 5MB.
                                </div>
                                <div v-if="livenessVerified" class="form-text text-success mt-2">
                                    Profile photo verified. Image selection is locked.
                                </div>
                            </div>

                            <div class="mt-3 image-preview" v-if="imagePreview">
                                <img
                                :src="imagePreview"
                                alt="Profile Preview"
                                class="img-thumbnail"
                                style="max-width: 150px;"
                                />
                            </div>
                            
                            <!-- LIVENESS CHECK SECTION -->
                            <div class="mt-4" v-if="imagePreview">
                                <div class="liveness-check-card p-3 border rounded" style="background: rgba(211, 62, 116, 0.1); border-color: #D33E74;">
                                    <h6 class="text-white fw-bold mb-3">
                                        <i class="fa fa-shield"></i> Identity Verification
                                    </h6>
                                    <p class="text-white mb-3" style="font-size: 13px; color: #fff;">
                                        We need to verify you're the person in the photo. This is a quick check to ensure platform safety.
                                    </p>
                                    
                                    <button 
                                        type="button"
                                        class="btn btn-warning fw-bold"
                                        @click="openLivenessModal"
                                        v-if="!livenessVerified"
                                        style="background: #FF8A00; border-color: #FF8A00;"
                                    >
                                        <i class="fa fa-camera me-2"></i> Start Verification
                                    </button>
                                    
                                    <div v-else class="alert alert-success mb-0" style="background: rgba(61, 182, 92, 0.2); border-color: #3db65c; color: #fff;">
                                        <i class="fa fa-check-circle me-2"></i> <strong>✓ Verified</strong> - Identity confirmed
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row">
                        <label for=""> Password</label>
                        <input type="password" class="form-control input-text pwd" v-model="password" minlength="5" maxlength="12" placeholder="Your password" required>
                    </div>
                    <div class="row">
                        <label for=""> Firstname</label>
                        <input type="text" class="form-control input-text" v-model="firstname" placeholder="Your first name" required>
                    </div>
                    <div class="row">
                        <label for=""> Lastname</label>
                        <input type="text" class="form-control input-text" v-model="lastname" placeholder="Your last name" required>
                    </div>
                    <div class="row">
                        <label for=""> Email</label>
                        <input type="email" class="form-control input-text" v-model="email" placeholder="Your email" required>
                    </div>
                    <div class="row">
                        <label for=""> Phone</label>
                        <input type="text" class="form-control input-text" v-model="phone" placeholder="Your phone number" required>
                    </div>
                    <div class="row birthday">
                        <label for="">Birthday</label>
                        <div class="col-md-4">
                            <select name="" id="" class="form-control input-select" v-model="day" required>
                                <option value="">Day</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>
                                <option value="20">20</option>
                                <option value="21">21</option>
                                <option value="22">22</option>
                                <option value="23">23</option>
                                <option value="24">24</option>
                                <option value="25">25</option>
                                <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                <option value="30">30</option>
                                <option value="31">31</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <select name="" id="" class="form-control input-select" v-model="month" required>
                                <option value="">Month</option>
                                <option value="01">January</option>
                                <option value="02">February</option>
                                <option value="03">March</option>
                                <option value="04">April</option>
                                <option value="05">May</option>
                                <option value="06">June</option>
                                <option value="07">July</option>
                                <option value="08">August</option>
                                <option value="09">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <select name="" id="year" class="form-control input-select" v-model="year" required>
                            </select>
                        </div>
                    </div>
                    <div class="row gender-row">
                        <label for="">Gender</label>
                        <div class="col-md-5 gender">
                            <img src="../../assets/male.png" alt="male"> <input type="radio" value="Male" name="male" class="form-check-input" v-model="gender" required> Male
                        </div>
                        <div class="col-md-5 gender gender-top">
                            <img src="../../assets/female.png" alt="female"> <input type="radio" value="Female" name="female" class="form-check-input" v-model="gender" required> Female
                        </div>
                    </div>
                    <div class="row">
                        <label for="">Country</label>
                        <input type="text" class="form-control input-text" v-model="user_country" placeholder="Country (e.g Nigeria)">
                    </div>
                    <div class="row">
                        <label for="">State</label>
                        <select name="" id="" class="form-control location" v-model="state" required>
                            <option value="">Select</option>
                            <option v-for="(i, index) in options" :key="index" :value="i.state">{{i.state}}</option>
                        </select>
                    </div>
                    <div class="row">
                        <label for="">Location</label>
                        <input type="text" class="form-control input-text" v-model="site_location" placeholder="Your Location (e.g Maitama)" required>
                    </div>
                    <div class="row">
                        <label for=""> About you</label>
                        <textarea name="" id="" cols="30" rows="10" class="form-control input-text" v-model="aboutyou" placeholder="Tell us a bit about yourself"></textarea>
                    </div>
                    <div class="row">
                        <button class="btn-next" @click="submit()" v-if="!loading"> Submit </button>
                        <button class="btn-next" type="button" disabled v-if="loading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                    </div>
                </span>
            </div>
            <div class="card1-spacer"></div>
        </div>
        <!-- forgot password Modal -->
        <div id="success" class="modal-window">
            <div class="row">
                <div class="col-md-1">
                
                </div>
                <div class="col-md-10">
                    <div class="row">
                        <span class="modal-logo">
                            <img src="../../assets/success.png" alt="letsplay">
                        </span>
                        <h6 style="color:#fff">
                            Registration successful! &nbsp; {{ success_message }}
                        </h6>
                        <p class="welcome">Now let’s find you a perfect match!</p>
                        
                        <div class="row">
                            <router-link to="/"><button class="btn-proceed">Ok</button></router-link>
                        </div>
                    </div>                
                </div>
                <div class="col-md-1">
                    <div>
                    
                    </div>
                </div>
    
            </div>
        </div>

        <!-- LIVENESS CHECK MODAL -->
        <div v-if="showLivenessModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0, 0, 0, 0.7);">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%); border: 1px solid #D33E74;">
              <div class="modal-header border-0 pb-2" style="background: linear-gradient(90deg, #D33E74, #ff6b6b);">
                <h5 class="modal-title text-white fw-bold">
                  <i class="fa fa-shield me-2"></i> Identity Verification
                </h5>
                <button type="button" class="btn-close btn-close-white" @click="closeLivenessModal" :disabled="livenessLoading"></button>
              </div>
              <div class="modal-body p-4">
                <div class="text-center">
                  <!-- LIVE CAMERA FEED -->
                  <video 
                    id="livenessVideo" 
                    width="100%" 
                    height="auto"
                    autoplay 
                    playsinline
                    muted
                    style="background: #000; border-radius: 8px; margin-bottom: 15px; max-height: 320px;"
                  ></video>

                  <p class="text-white mb-3 fw-semibold">Position your face in frame</p>
                  
                  <!-- FRAME CAPTURE PROGRESS -->
                  <div class="progress mb-3" style="background: rgba(211, 62, 116, 0.2); height: 25px; border-radius: 4px;">
                    <div 
                      class="progress-bar" 
                      role="progressbar" 
                      :style="{ width: (framesCaptured / livenessFrameCount * 100) + '%', background: '#D33E74' }"
                      :aria-valuenow="framesCaptured" 
                      :aria-valuemin="0" 
                      :aria-valuemax="livenessFrameCount"
                    >
                      {{ framesCaptured }}/{{ livenessFrameCount }} frames
                    </div>
                  </div>
                  
                  <div class="verification-steps text-white text-start mb-4" style="background: rgba(211, 62, 116, 0.1); padding: 15px; border-radius: 8px; border-left: 4px solid #D33E74;">
                    <p class="mb-2"><i class="fa fa-check-circle" style="color: #3db65c;"></i> Look straight at the camera</p>
                    <p class="mb-2"><i class="fa fa-check-circle" style="color: #3db65c;"></i> Keep good lighting on your face</p>
                    <p class="mb-2"><i class="fa fa-check-circle" style="color: #3db65c;"></i> Avoid sunglasses and hats</p>
                    <p class="mb-0"><i class="fa fa-check-circle" style="color: #3db65c;"></i> Make sure you match your profile photo</p>
                  </div>

                  <div v-if="livenessError" class="alert alert-danger mb-3"><i class="fa fa-exclamation-circle me-2"></i> {{ livenessError }}</div>

                  <p class="text-muted" style="font-size: 12px;">Data is encrypted and used only for verification purposes.</p>
                </div>
              </div>
              <div class="modal-footer border-0 pt-2" style="background: rgba(211, 62, 116, 0.1);">
                <button type="button" class="btn btn-secondary" @click="closeLivenessModal" :disabled="livenessLoading">Cancel</button>
                <button type="button" class="btn btn-warning text-dark fw-bold" @click="completeLivenessCheck" :disabled="livenessLoading">
                  <i v-if="!livenessLoading" class="fa fa-check me-2"></i>
                  <i v-else class="fas fa-spinner fa-spin me-2"></i>
                  {{ livenessLoading ? `Verifying (${framesCaptured}/${livenessFrameCount})...` : 'Complete Verification' }}
                </button>
              </div>
            </div>
          </div>
        </div>
    </div>
    </template>
    <script>
    import Vue from 'vue'
    //import $ from 'jquery';
    import swal from 'sweetalert2';
    import VueCountryDropdown from "vue-country-dropdown";

    Vue.use(VueCountryDropdown);
    
    export default {
        //components: { VueCountryDropdown },
    data() {
      return {
        personal_information: true,
        other_information: false,
        firstname: '',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        day: '',
        month: '',
        year: '',
        gender: '',
        state: '',
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
        loading1: false,
        response: '',
        record_id: '',
        options: [],
        musicx: '',
        dancex: '',
        foodx: '',
        fashionx: '',
        photographyx: '',
        travelx: '',
        cookingx: '',
        is_nigeria: false,
        user_country: '',
        country_dial_code:'',
        country_iso2: '',
        success_message: '',
        is_referred: false,
        referral_code:'',
        referral_option: '',
        password: '',
        cpassword:'',
        imagePreview: null,
        profilePictureFile: null,
        site_location: '',
        slogan: '',
        logoutSplash: false,
        logoutMessage: "",
        account_type: '',
        showLivenessModal: false,
        livenessVerified: false,
        livenessLoading: false,
        livenessError: '',
        cameraActive: false,
        cameraStream: null,
        capturedFrame: null,
        profilePictureUrl: '',
        capturedFrameUrl: '',
        livenessImages: [],
        livenessFrameCount: 6,
        framesCaptured: 0,
        frameCaptureInterval: null,
        userId: null,
        faceCompareScore: null
    
      };
    },
    
    beforeMount(){
        this.getStates()
    },
    
    mounted(){
        this.years()
        localStorage.removeItem("wertyuiojhdfghhdrtfyguh")
    },
    
    methods: {

    onFileChange(event) {
      if (this.livenessVerified) {
        return;
      }

      const file = event.target.files[0];
        if (file && file.type.startsWith("image/")) {
            this.imagePreview = URL.createObjectURL(file);
            this.profilePictureFile = file;
            this.profilePictureUrl = '';
        } else {
        this.imagePreview = null;
        this.profilePictureFile = null;
        this.profilePictureUrl = '';
        }
    },

       onSelect({name, iso2, dialCode}) {
            this.country_iso2 = iso2
            this.user_country = name
            this.country_dial_code = dialCode
       if(this.country_dial_code == '234'){
            this.is_nigeria = true
       }
       else {
            this.is_nigeria = false
       }
     },
     referralOption(){

        if (this.referral_option == '1'){
            this.is_referred = true
        }
        else if (this.referral_option == '2'){
            this.is_referred = false
        }
     },
        years() {
           
                var year_satart = 1940;
                var year_end = (new Date).getFullYear(); // current year
                //var year_selected = 1992;
    
                var option = '';
                option = '<option value="">Year</option>'; // first option
    
                for (var i = year_satart; i <= year_end; i++) {
                   // var selected = (i === year_selected ? ' selected' : '');
                    //var arabic_number = to_arabic(i); // number convert to arabic digit
                    option += '<option value="' + i + '"' + i + '>' + i + '</option>';
                }
    
                document.getElementById("year").innerHTML = option;
        
        },
        
       
        
        pwdCheck() {
            var length = this.password.length; // get password length

            if(length>=5) {
                var char = document.getElementsByClassName("five-char")
                char[0].style.color = "green";
                
                var bi = document.getElementsByClassName("btn-next")
                bi[0].disabled = false;
            }
            else {
                var char7 = document.getElementsByClassName("five-char")
                char7[0].style.color = "red";

                var b = document.getElementsByClassName("btn-next")
                b[0].disabled = true;
            }
            // check for uppercase
            if(this.containsUppercase(this.password) == true) {
                var char2 = document.getElementsByClassName("uppercase")
                char2[0].style.color = "green";

                var bx = document.getElementsByClassName("btn-next")
                bx[0].disabled = false;
            }
            else {
                var char6 = document.getElementsByClassName("uppercase")
                char6[0].style.color = "red";

                var r = document.getElementsByClassName("btn-next")
                r[0].disabled = true;
            }
            // check for special char
            if(this.containsSpecialChars(this.password) == true) {
                var char1 = document.getElementsByClassName("special-char")
                char1[0].style.color = "green";

                var x = document.getElementsByClassName("btn-next")
                x[0].disabled = false;
            }
            else {
                var char5 = document.getElementsByClassName("special-char")
                char5[0].style.color = "red";

                var y = document.getElementsByClassName("btn-next")
                y[0].disabled = true;
            }
            // check for numbers
            if(this.containsNumber(this.password) == true) {
                var char3 = document.getElementsByClassName("number")
                char3[0].style.color = "green";

                var v = document.getElementsByClassName("btn-next")
                v[0].disabled = false;
            }
            else {
                var char4 = document.getElementsByClassName("number")
                char4[0].style.color = "red";

                var s = document.getElementsByClassName("btn-next")
                s[0].disabled = true;
            }
            
        },

        cpwdCheck() {
            if(this.password == this.cpassword) {
                var char3 = document.getElementsByClassName("cpwd")
                char3[0].style.color = "green";

                var cha = document.getElementsByClassName("pwd")
                cha[0].style.color = "green";

                var chars = document.getElementsByClassName("password-match")
                chars[0].style.color = "green";

            }
            else{
                var c = document.getElementsByClassName("cpwd")
                c[0].style.color = "red";

                var ch = document.getElementsByClassName("pwd")
                ch[0].style.color = "red";

                var charx = document.getElementsByClassName("password-match")
                charx[0].style.color = "red";
            }

        },

        containsUppercase(str) {
            return /[A-Z]/.test(str);
        },

        containsSpecialChars(str) {
            //eslint-disable-next-line
            const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            return specialChars.test(str);
        },
        containsNumber(str) {
            return /\d/.test(str);
        },

    async submit() {
    try {
        // Validate Required Fields
        if (!this.account_type || !this.profile_name || !this.firstname || !this.lastname || !this.email || !this.phone || !this.day || !this.month || !this.year || !this.state ||!this.site_location || !this.password) {
        swal.fire({
            icon: 'warning',
            title: 'Error...',
            width: 450,
            text: 'Please fill all required fields.',
        });
        return;
        }

        // Validate Liveness Check
        if (!this.livenessVerified) {
        swal.fire({
            icon: 'warning',
            title: 'Identity Verification Required',
            width: 450,
            text: 'Please complete the identity verification (liveness check) to proceed.',
        });
        return;
        }

        this.loading = true;

        // Format birthday
        const birthday = `${this.year}-${this.month}-${this.day}`;

        // Build FormData for image upload
        const formData = new FormData();
        formData.append('account_type', this.account_type)
        formData.append('firstname', this.firstname);
        formData.append('lastname', this.lastname);
        formData.append('profile_name', this.profile_name);
        formData.append('slogan', this.slogan);
        formData.append('email', this.email);
        formData.append('phone', this.phone);
        formData.append('birthday', birthday);
        formData.append('gender', this.gender);
        formData.append('country', this.user_country);
        formData.append('state', this.state);
        formData.append('site_location', this.site_location);
        formData.append('aboutyou', this.aboutyou);
        formData.append('password', this.password);
        formData.append('role', this.account_type); //Specify escort role

        // Attach file
        if (this.profilePictureFile) {
            formData.append('profile_picture', this.profilePictureFile);
        }

        // Submit via axios or $http
        this.response = await this.$http.post('/sign_up', formData, {
            headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'multipart/form-data' 
            },
        });

        this.loading = false;

        if (this.response.data.success) {
         // Set splash message
        this.logoutMessage = this.response.data.message || "Not successful!";
        this.logoutSplash = true;

        // Clear form fields
        this.firstname = '';
        this.lastname = '';
        this.email = '';
        this.phone = '';
        this.password = '';
        this.cpassword = '';
        this.profile_name = '';
        this.site_location = ''
        this.aboutyou = ''
        this.slogan = ''
        this.account_type = ''
        this.profilePictureFile = null;
        this.imagePreview = null;

        setTimeout(() => {
            this.logoutSplash = false;
            this.$router.push('/login')
        }, 2500); // splash visible for 2.5 seconds

        } else {
        
             // Set splash message
            this.logoutMessage = this.response.data.message || "Not successful!";
            this.logoutSplash = true;

            setTimeout(() => {
             this.logoutSplash = false;
           }, 4500); // splash visible for 2.5 seconds

        }
    } catch (err) {
        console.log(err);
        this.loading = false;

         // Set splash message
        this.logoutMessage = err.response ? err.response.data.message : err.message,
        this.logoutSplash = true;

        setTimeout(() => {
            this.logoutSplash = false;
        }, 4500); // splash visible for 2.5 seconds

      }
    },

    openLivenessModal() {
      this.showLivenessModal = true;
      this.livenessError = '';
      this.$nextTick(() => {
        this.initializeCamera();
      });
    },

    closeLivenessModal() {
      this.stopCamera();
      this.showLivenessModal = false;
      this.livenessError = '';
      this.livenessImages = [];
      this.framesCaptured = 0;
    },

    async initializeCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 } }
        });
        this.cameraStream = stream;
        const video = document.getElementById('livenessVideo');
        if (video) {
          video.srcObject = stream;
          this.cameraActive = true;
        }
      } catch (err) {
        this.livenessError = 'Camera access denied. Please enable camera permissions in your browser settings.';
        console.error('Camera error:', err);
      }
    },

    stopCamera() {
      if (this.cameraStream) {
        this.cameraStream.getTracks().forEach(track => track.stop());
        this.cameraStream = null;
        this.cameraActive = false;
      }
    },

    captureFrame() {
      try {
        const video = document.getElementById('livenessVideo');
        if (video && this.cameraActive) {
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0);
          this.capturedFrame = canvas.toDataURL('image/jpeg');
          return this.capturedFrame;
        }
      } catch (err) {
        console.error('Frame capture error:', err);
      }
      return null;
    },

    async completeLivenessCheck() {
      try {
        if (!this.cameraActive) {
          this.livenessError = 'Camera is not active. Please try again.';
          return;
        }

        this.livenessLoading = true;
        this.livenessError = '';
        this.livenessImages = [];
        this.framesCaptured = 0;

        // Capture 6 frames at intervals
        await this.captureMultipleFrames();

        if (this.livenessImages.length < this.livenessFrameCount) {
          throw new Error(`Failed to capture enough frames. Got ${this.livenessImages.length}, needed ${this.livenessFrameCount}`);
        }

        if (!this.profilePictureFile) {
          throw new Error('Please upload a profile picture before verification.');
        }

        if (!this.capturedFrame) {
          throw new Error('Unable to capture the selfie frame. Please try again.');
        }

        // Compare uploaded profile photo with the live selfie frame
        await this.sendVerificationRequest();

        // Mark as verified
        this.livenessVerified = true;
        this.livenessLoading = false;
        this.stopCamera();
        this.closeLivenessModal();

      } catch (err) {
        this.livenessLoading = false;
        this.livenessError = err.message || 'Verification failed. Please try again.';
        console.error('Liveness check error:', err);
      }
    },

    async captureMultipleFrames() {
      return new Promise((resolve, reject) => {
        let captureCount = 0;
        const captureInterval = setInterval(() => {
          try {
            const frameData = this.captureFrame();
            if (frameData) {
              // Convert data URL to Blob
              this.dataURLtoBlob(frameData).then(blob => {
                this.livenessImages.push(blob);
                this.framesCaptured = this.livenessImages.length;
                captureCount++;

                if (captureCount >= this.livenessFrameCount) {
                  clearInterval(captureInterval);
                  resolve();
                }
              });
            }
          } catch (err) {
            clearInterval(captureInterval);
            reject(err);
          }
        }, 300); // Capture every 300ms
      });
    },

    dataURLtoBlob(dataURL) {
      return new Promise((resolve) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        resolve(new Blob([u8arr], { type: mime }));
      });
    },

    fileToDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Unable to read the image file.'));
        reader.readAsDataURL(file);
      });
    },

    async sendVerificationRequest() {
      try {
        if (!this.profilePictureFile) {
          throw new Error('Please upload a profile image first.');
        }

        if (!this.capturedFrame) {
          throw new Error('Unable to capture the live selfie. Please try again.');
        }

        const profileImageUrl = await this.uploadImage(this.profilePictureFile);
        if (!profileImageUrl) {
          throw new Error('Profile image upload failed. Please try again.');
        }

        const selfieBlob = await this.dataURLtoBlob(this.capturedFrame);
        const selfieImageUrl = await this.capturedImage(selfieBlob);
        if (!selfieImageUrl) {
          throw new Error('Selfie upload failed. Please try again.');
        }

        this.profilePictureUrl = profileImageUrl;
        this.capturedFrameUrl = selfieImageUrl;

        const data = await this.compareImages(profileImageUrl, selfieImageUrl) || {};
        const comparisons = Array.isArray(data.comparisons) ? data.comparisons : [];
        const firstComparison = comparisons[0] || {};
        const distance = Number(firstComparison.distance);
        const facesImg1 = Number(data.faces_img1 ?? 0);
        const facesImg2 = Number(data.faces_img2 ?? 0);
        const isMatch = Number.isFinite(distance) && distance < 1.0;

        this.faceCompareScore = Number.isFinite(distance) ? distance : null;

        if (facesImg1 === 0 || facesImg2 === 0) {
          throw new Error('No face detected in one of the images. Please try again.');
        }

        if (!isMatch) {
          throw new Error(
            `Face comparison did not match. Distance: ${Number.isFinite(distance) ? distance.toFixed(4) : 'unknown'}. Please try again.`
          );
        }

        swal.fire({
          icon: 'success',
          title: 'Verified!',
          text: `Your profile photo matched the live selfie successfully.`,
          confirmButtonColor: '#D33E74'
        });

      } catch (err) {
        console.error('Verification request error:', err);
        throw new Error(err.response?.data?.message || err.message || 'Failed to send verification request');
      }
    },

    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

        async getStates() {
            try{
                const response = await this.$http.get('state/fetch', {
                    headers: { 
                    "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                    'Content-Type': 'application/json' 
                },
                })
                this.options = response.data.states;
        
                }catch (err) {
                    console.log(err);
            }
        },

        async compareImages(image1, image2){
            try{
                const response = await this.$http.post('compare-image', {
                    image1: image1,
                    image2: image2
                })
                return response.data.data;
        
                }catch (err) {
                    console.log(err);
            }
        },

        async uploadImage(profileImage) {
        try {
        
            // Build FormData for image upload
            const formData = new FormData();

            // Attach file
            if (profileImage) {
                formData.append('upload_profile_image', profileImage);
            }

            // Submit via axios or $http
            const response = await this.$http.post('/upload-image', formData, {
            });


            if (response.data.success) {

            // Clear form fields
            this.profilePictureUrl = response.data.data;
            return response.data.data;


            } else {
            
                // Set splash message
                this.logoutMessage = response.data.message || "Not successful!";
                this.logoutSplash = true;

                setTimeout(() => {
                this.logoutSplash = false;
            }, 4500); // splash visible for 2.5 seconds

            return '';

            }
        } catch (err) {
            console.log(err);
            this.loading = false;

            // Set splash message
            this.logoutMessage = err.response ? err.response.data.message : err.message,
            this.logoutSplash = true;

            setTimeout(() => {
                this.logoutSplash = false;
            }, 4500); // splash visible for 2.5 seconds

            return '';

        }
        },

        async capturedImage(profileImage) {
        try {
        
            // Build FormData for image upload
            const formData = new FormData();

            // Attach file
            if (profileImage) {
                formData.append('upload_profile_image', profileImage);
            }

            // Submit via axios or $http
            const response = await this.$http.post('/upload-image', formData, {
            });


            if (response.data.success) {

            // Clear form fields
            this.capturedFrameUrl = response.data.data;
            return response.data.data;


            } else {
            
                // Set splash message
                this.logoutMessage = response.data.message || "Not successful!";
                this.logoutSplash = true;

                setTimeout(() => {
                this.logoutSplash = false;
            }, 4500); // splash visible for 2.5 seconds

            return '';

            }
        } catch (err) {
            console.log(err);
            this.loading = false;

            // Set splash message
            this.logoutMessage = err.response ? err.response.data.message : err.message,
            this.logoutSplash = true;

            setTimeout(() => {
                this.logoutSplash = false;
            }, 4500); // splash visible for 2.5 seconds

            return '';

        }
        },

      }
    }
    </script>
    
<style lang="scss" scoped>
 .logout-splash {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      font-family: 'Raleway';
      font-style: normal;
      background-color: #0A070F; /* green success */
      color: white;
      padding: 15px;
      text-align: center;
      font-weight: bold;
      z-index: 9999;
      box-shadow: 0 2px 5px rgba(0,0,0,0.3);
      transition: top 0.3s ease-in-out;
}

    .image-preview{
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .img-thumbnail {
        border-radius: 0.5rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .password-check{
        margin-top:10px;
        width: 100%!important;
        font-size: 10px;
        .five-char {
            color: red
        }
        .uppercase{
            color: red
        }
        .number{
            color: red
        }
        .special-char{
            color: red
        }
        .password-match{
            color: red
        }
    }
    a {
        text-decoration: none;
    }
    body {
        background: #0A070F !important;
    }
    .modal-window {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        transition: all 0.3s;
        &:target {
          visibility: visible;
          opacity: 1;
          pointer-events: auto;
        }
        & > div {
          width: 680px;
          height: 400px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          padding: 2em;
          position: absolute;
          width: 372px;
          height: 420px;
          background: #19181B;
          border-radius: 50px;
        }
        header {
          font-weight: bold;
        }
        h1 {
          font-size: 150%;
          margin: 0 0 15px;
        }
        h2 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 23px;
            text-align: center;
            color: #FFFFFF;
        }
        .welcome {
            margin-top: 15px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 23px;
            text-align: center;
            color: #FFFFFF;
        }
        label {
            text-align: left;
            color: #fff;
            font-size: 12px;
            margin-left:15px;
            margin-bottom: -6px;
        }
        span {
            margin-bottom: 20px;
        }
    
      }
      
      .modal-close {
        color: #fff;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
        &:hover {
          color: black;
        }
      }
      .modal-close-mobile {
        color: #fff;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
        &:hover {
          color: black;
        }
        display: none;
      }
      .modal-window {
        & > div {
            border-radius: 63px;
        }
      }
      .modal-logo {
        text-align: center;
      }
      .modal-logo > img {
        width: 100px;
        height: 100;
    }
    h2 {
       
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
        line-height: 190%;
        margin-top: 20px;
    
    }
    .modal-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 52px;
        gap: 19px;
        width: 380px;
        height: 50px;
        background: #FFFFFF;
        border-radius: 50px;
        margin: 3%;
        cursor: pointer;
    }
    .login-modal-box {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 52px;
        gap: 311px;
        width: 496px;
        height: 45px;
        background: #0A070F;
        border: 0.5px solid #FFFFFF;
        border-radius: 50px;
        margin: 10px;
        color: #767475;
    }
    .btn-proceed {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px;
        gap: 10px;
        width: 250px;
        height: 40px;
        background: #D33E74;
        border-radius: 82px;
        color: #FFFFFF;
        margin-left: -10px;
    }
    .container-fluid{
        background: #0A070F;
        width: 100%;
    
        .container{
            background: transparent;
            display:flex;
            flex-direction: row;
            justify-content:space-evenly;
            width: 100% !important;
            margin-top: 60px;

            .card1{
                margin: 6px;
                width: 40%;
                height: auto;
                padding: 4px;
                background: transparent;
            }

            .card{
                margin: 6px;
                width: 60%;
                height: auto;
                padding: 4px;
                background: transparent;
            }
    
            h4 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 30px;
                line-height: 42px;
                text-align: center;
                
                a{
                    text-decoration: none;
                    color: #D33E74;
                }
            }
            h2 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 36px;
                line-height: 42px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 23px;
                text-align: center;
                color: #FFFFFF;
            }     
    
            .signup-toggle {
                width: 100%;
                height: 80px;
                background: #1C1B1E;
                border-radius: 50px;
                display: flex;
                flex-direction: row;
                padding: 15px;
                margin-bottom: 20px;
                cursor: pointer;
                font-size: 11px;
    
                .personal-info {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    gap: 10px;
                    width: 100%;
                    height: 51px;
                    background: #D33E74;
                    border-radius: 50px;
                    color:#FFFFFF;
                    font-size: 12px;
                }
                .other-info {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    gap: 10px;
                    width: 222px;
                    height: 51px;
                    border-radius: 50px;
                    color:#FFFFFF
                }
            }
            .form-group {
                margin: 4px;
            }
            .input-text {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 52px;
                gap: 19px;
                width: 100%;
                height: 55px;
                background: #0A070F;
                border: 0.5px solid #FFFFFF;
                border-radius: 50px;
                color: #767475;
                font-size:11px;
    
            }
            .birthday {
                margin-left: -20px;
            }
    
            input:focus {
                border: 0.5px solid #D33E74;
            }
            select:focus {
                border: 0.5px solid #D33E74;
            }
            textarea:focus {
                border: 0.5px solid #D33E74;
            }
            option:focus {
                border: 0.5px solid #D33E74;
            }
            .input-select {
                box-sizing: border-box;
                align-items: center;
                padding: 10px 40px;
                width: 100%;
                height: 55px;
                background: #0A070F;
                border: 0.5px solid #FFFFFF;
                border-radius: 50px;
                color: #767475;
                font-size:11px;
            }
            label {
                text-align: left;
                color: #FFFFFF;
                margin-left:4px;
                margin-top: 10px;
            }
            .gender-row{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
    
            .gender {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 40px;
                height: 55px;
                background: #0A070F;
                border: 0.5px solid #FFFFFF;
                border-radius: 50px;
                font-size:11px;
                color: #767475;
                
            }
            .location {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 52px;
                gap: 202px;
                width: 100%;
                height: 55px;
                background: #0A070F;
                border: 0.5px solid #FFFFFF;
                border-radius: 50px;
                color: #767475;
                font-size:11px;
            }
            .btn-next {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                gap: 10px;
                width: 100%;
                height: 50px;
                background: #fff;
                border-radius: 82px;
                margin-top: 40px;
                margin-bottom: 40px;
                color:#0A070F;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 600;
                font-size: 18px;
                line-height: 28px;
            }
            .btn-done {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                gap: 10px;
                width: 435px;
                height: 50px;
                background: #D33E74;
                border-radius: 82px;
                margin-top: 40px;
                margin-bottom: 40px;
                color:#FFFFFF;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 600;
                font-size: 18px;
                line-height: 28px;
            }
        }
        .header {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px;
            gap: 900px;
            width: 1514px;
            height: 105px;
            background: #0A070F;
            margin-left: 0px;
            width: 100%;
        
            .logo > img{
                width: 150px;
                height: 30px;
            }
         }
         .btn-chips {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 40px;
            gap: 19px;
            width: 117.61px;
            height: 35px;
            background: #0A070F;
            border: 0.5px solid #FFFFFF;
            border-radius: 50px;
            margin:6px;
            color:#767475;
         }
         .btn-chips:hover {
            border: 0.5px solid #D33E74;
         }
         .rel-goal{
            color:#D33E74;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
        }
    
    }

    @media screen and (max-width: 768px) {
        .modal-window {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 999;
            visibility: hidden;
            opacity: 0;
            pointer-events: none;
            transition: all 0.3s;
            &:target {
              visibility: visible;
              opacity: 1;
              pointer-events: auto;
            }
            & > div {
              width: 680px;
              height: 490px;
              position: absolute;
              top: 50%;
              left: 53%;
              transform: translate(-50%, -50%);
              padding: 2em;
              position: absolute;
              width: 300px;
              height: 400px;
              background: #19181B;
              border-radius: 50px;
            }
            header {
              font-weight: bold;
            }
            h1 {
              font-size: 150%;
              margin: 0 0 15px;
            }
            h2 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 23px;
                text-align: center;
                color: #FFFFFF;
            }
            .welcome {
                margin-top: 15px;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 23px;
                text-align: center;
                color: #FFFFFF;
            }
            label {
                text-align: left;
                color: #fff;
                font-size: 12px;
                margin-left:15px;
                margin-bottom: -6px;
            }
            span {
                margin-bottom: 20px;
            }
        
          }
          
          .modal-close {
            color: #fff;
            line-height: 50px;
            font-size: 140%;
            position: absolute;
            right: 0;
            text-align: center;
            top: 2;
            width: 70px;
            text-decoration: none;
            &:hover {
              color: black;
            }
          }
          .modal-close-mobile {
            color: #fff;
            line-height: 50px;
            font-size: 140%;
            position: absolute;
            right: 0;
            text-align: center;
            top: 2;
            width: 70px;
            text-decoration: none;
            &:hover {
              color: black;
            }
            display: none;
          }
          .modal-window {
            & > div {
                border-radius: 63px;
            }
          }
          .modal-logo > img {
            margin-top: -30px;
            width: 120px;
            height: 120;
        }
        h2 {
           
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 18px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
            line-height: 190%;
            margin-top: 20px;
        
        }
        .modal-box {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px 52px;
            gap: 19px;
            width: 380px;
            height: 50px;
            background: #FFFFFF;
            border-radius: 50px;
            margin: 3%;
            cursor: pointer;
        }
        .login-modal-box {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 10px 52px;
            gap: 311px;
            width: 496px;
            height: 45px;
            background: #0A070F;
            border: 0.5px solid #FFFFFF;
            border-radius: 50px;
            margin: 10px;
            color: #767475;
        }
        .btn-proceed {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            gap: 10px;
            width: 235px;
            height: 35px;
            background: #D33E74;
            border-radius: 82px;
            color: #FFFFFF;
            margin-left: -10px;
            font-size: 13px;
        }
    }
    
    @media screen and (max-width: 768px) {
    
        .container-fluid{
            background: #0A070F;
            width: 100%;
            height: auto;
            margin: 0;
        
            .container{
                background: #0A070F;
                margin-top: 80px;
                width: 100%;
                height: 100%;
                display:flex;
                flex-direction: column;
                justify-content:space-evenly;
        
                h2 {
                    font-family: 'Raleway';
                    font-style: normal;
                    font-weight: 800;
                    font-size: 30px;
                    line-height: 42px;
                    text-align: center;
                    color: #FFFFFF;
                }
                p {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12.5px;
                    line-height: 23px;
                    text-align: center;
                    color: #FFFFFF;
                }     
        
                .signup-toggle {
                    width: 100%;
                    height: 80px;
                    background: #1C1B1E;
                    border-radius: 50px;
                    display: flex;
                    flex-direction: row;
                    padding: 15px;
                    margin-bottom: 20px;
        
                    .personal-info {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        padding: 10px;
                        
                        width: 100%;
                        height: 51px;
                        background: #D33E74;
                        border-radius: 50px;
                        color:#FFFFFF;
                        font-size: 12px;
                    }
                    .other-info {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        padding: 10px;
                        gap: 10px;
                        width: 222px;
                        height: 51px;
                        border-radius: 50px;
                        color:#FFFFFF;
                        font-size: 12px;
                    }
                }
                .form-group {
                    margin: 4px;
                }
                .input-text {
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 10px 30px;
                    //gap: 19px;
                    width: 100%;
                    height: 40px;
                    background: #0A070F;
                    border: 0.5px solid #fff;
                    border-radius: 50px;
                }
                input:focus {
                    border: 0.5px solid #D33E74;
                }
                select:focus {
                    border: 0.5px solid #D33E74;
                }
                textarea:focus {
                    border: 0.5px solid #D33E74;
                }
                option:focus {
                    border: 0.5px solid #D33E74;
                }
                .birthday {
                    margin-left: -30px;
                }
                .input-select {
                    box-sizing: border-box;
                    align-items: center;
                    padding: 10px 40px;
                    width: 100%;
                    height: 40px;
                    background: #0A070F;
                    border: 0.5px solid #FFFFFF;
                    border-radius: 50px;
                    margin: 2px;
                }
                label {
                    text-align: left;
                    color: #FFFFFF;
                    margin-left:4px;
                    margin-top: 10px;
                    font-size:12px;
                }
                .gender-top{
                    margin-top: 4px !important;
                }
                .gender {
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 10px 40px;
                    width: 100%;
                    height: 40px;
                    background: #0A070F;
                    border: 0.5px solid #FFFFFF;
                    border-radius: 50px;
                    margin: 0px;
                }
                .location {
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 10px 10px;
                    width: 100% !important;
                    height: 40px;
                    background: #0A070F;
                    border: 0.5px solid #FFFFFF;
                    border-radius: 50px;
                    color: #FFFFFF !important;
                }
                .btn-next {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    gap: 10px;
                    width: 100%;
                    height: 42px;
                    background: #D33E74;
                    border-radius: 82px;
                    margin-top: 40px;
                    margin-bottom: 40px;
                    color:#FFFFFF;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 28px;
                }
                .btn-done {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    gap: 10px;
                    width: 100%;
                    height: 42px;
                    background: #D33E74;
                    border-radius: 82px;
                    margin-top: 40px;
                    margin-bottom: 40px;
                    margin-left: -10px;
                    color:#FFFFFF;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 28px;
    
                }

            }

            .gender-row{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            .card1{
                display: none;
            }

            .card{
                margin: 0 !important;
                width: 100% !important;
            }
            .header {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 0px;
                gap: 900px;
                width: 1514px;
                height: 105px;
                background: #0A070F;
                margin-left: 0px;
                width: 100%;
            
                .logo > img{
                    width: 190px;
                    height: 30px;
                }
             }
        
        }
    }

    .signup-page {
        min-height: 100vh;
        background:
          radial-gradient(circle at top left, rgba(211, 62, 116, 0.18), transparent 32%),
          radial-gradient(circle at bottom right, rgba(255, 138, 0, 0.12), transparent 26%),
          linear-gradient(180deg, #09070d 0%, #0f0b14 100%);
    }

    .signup-page .signup-layout {
        display: grid;
        grid-template-columns: minmax(280px, 0.9fr) minmax(520px, 1.1fr);
        gap: 28px;
        align-items: stretch;
        width: min(1240px, 100%);
        padding: 56px 24px 72px;
        margin-top: 24px;
    }

    .signup-page .signup-hero,
    .signup-page .signup-card {
        background: rgba(14, 11, 20, 0.78);
        border: 1px solid rgba(255, 255, 255, 0.08);
        box-shadow: 0 24px 70px rgba(0, 0, 0, 0.38);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border-radius: 28px;
    }

    .signup-page .signup-hero {
        padding: 32px;
        display: flex;
        flex-direction: column;
        justify-content:flex-start;
        gap: 20px;
        color: #fff;
        min-height: 100%;
        position: relative;
        overflow: hidden;
    }

    .signup-page .signup-hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        width: fit-content;
        padding: 10px 14px;
        border-radius: 999px;
        background: rgba(211, 62, 116, 0.14);
        color: #ffbfd2;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.02em;
        margin-bottom: 10px;
        animation: signupFadeUp 0.7s ease both;
    }

    .signup-page .signup-hero h2 {
        text-align: left;
        font-size: clamp(30px, 4vw, 44px);
        line-height: 1.08;
        margin: 0 0 8px;
        color: #fff;
        max-width: 12ch;
    }

    .signup-page .signup-hero p {
        text-align: left;
        font-size: 16px;
        line-height: 1.7;
        color: rgba(255, 255, 255, 0.72);
        max-width: 44ch;
        margin: 0 0 10px;
    }

    .signup-page .signup-benefits {
        display: grid;
        gap: 14px;
        margin-top: 10px;
        animation: signupFadeUp 0.85s ease both;
    }

    .signup-page .benefit-item {
        display: grid;
        grid-template-columns: 42px 1fr;
        gap: 14px;
        align-items: start;
        padding: 16px 16px 16px 14px;
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.04);
        border: 1px solid rgba(255, 255, 255, 0.06);
        animation: signupFadeUp 0.8s ease both;
    }

    .signup-page .benefit-item:nth-child(2) {
        animation-delay: 0.08s;
    }

    .signup-page .benefit-item:nth-child(3) {
        animation-delay: 0.16s;
    }

    .signup-page .benefit-item i {
        width: 42px;
        height: 42px;
        border-radius: 14px;
        display: grid;
        place-items: center;
        background: linear-gradient(135deg, #d33e74, #ff8a00);
        color: #fff;
        font-size: 16px;
    }

    .signup-page .benefit-item strong {
        display: block;
        font-size: 15px;
        color: #fff;
        margin-bottom: 4px;
    }

    .signup-page .benefit-item span {
        display: block;
        margin-bottom: 0;
        color: rgba(255, 255, 255, 0.66);
        font-size: 13px;
        line-height: 1.5;
    }

    .signup-page .signup-card {
        padding: 28px 28px 24px;
        width: 100%;
        position: relative;
        overflow: hidden;
    }

    .signup-page .signup-card h2 {
        font-size: clamp(28px, 3vw, 38px);
        line-height: 1.1;
        text-align: left;
        margin: 4px 0 10px;
    }

    .signup-page .signup-card > p {
        text-align: left;
        color: rgba(255, 255, 255, 0.72);
        font-size: 15px;
        line-height: 1.7;
        margin-bottom: 22px;
        max-width: 60ch;
    }

    .signup-page .signup-toggle {
        background: rgba(255, 255, 255, 0.04);
        border: 1px solid rgba(255, 255, 255, 0.06);
        padding: 10px;
    }

    .signup-page .signup-toggle .personal-info {
        background: linear-gradient(135deg, #d33e74, #ff6b6b);
        box-shadow: 0 12px 24px rgba(211, 62, 116, 0.22);
    }

    .signup-page .input-text,
    .signup-page .input-select,
    .signup-page .gender,
    .signup-page .location {
        background: rgba(255, 255, 255, 0.03);
        border-color: rgba(255, 255, 255, 0.14);
        color: #fff;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
    }

    .signup-page .input-text::placeholder {
        color: rgba(255, 255, 255, 0.38);
    }

    .signup-page label {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.86);
        margin-bottom: 6px;
    }

    .signup-page .btn-next {
        background: linear-gradient(135deg, #fff 0%, #f1edf4 100%);
        color: #0a070f;
        border: none;
        box-shadow: 0 16px 30px rgba(0, 0, 0, 0.24);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .signup-page .btn-next:hover {
        transform: translateY(-1px);
        box-shadow: 0 20px 34px rgba(0, 0, 0, 0.28);
    }

    .signup-page .card1-spacer {
        display: none;
    }

    .signup-page .signup-hero::after,
    .signup-page .signup-card::after {
        content: "";
        position: absolute;
        inset: auto -120px -120px auto;
        width: 240px;
        height: 240px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(211, 62, 116, 0.18), transparent 65%);
        pointer-events: none;
    }

    .signup-page .signup-hero::before,
    .signup-page .signup-card::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.02), transparent 36%);
        pointer-events: none;
    }

    @keyframes signupFadeUp {
        from {
            opacity: 0;
            transform: translateY(18px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media screen and (max-width: 992px) {
        .signup-page .signup-layout {
            grid-template-columns: 1fr;
        }

        .signup-page .signup-hero {
            order: 2;
            padding: 24px;
        }

        .signup-page .signup-card {
            order: 1;
        }
    }

    @media screen and (max-width: 768px) {
        .signup-page .signup-layout {
            padding: 18px 14px 40px;
            gap: 14px;
        }

        .signup-page .signup-hero,
        .signup-page .signup-card {
            border-radius: 22px;
        }

        .signup-page .signup-hero {
            padding: 20px;
            gap: 14px;
        }

        .signup-page .signup-hero h2,
        .signup-page .signup-card h2 {
            font-size: 26px;
        }

        .signup-page .signup-card {
            padding: 20px 16px;
        }

        .signup-page .signup-card > p,
        .signup-page .signup-hero p {
            font-size: 14px;
        }

        .signup-page .benefit-item {
            grid-template-columns: 38px 1fr;
            padding: 14px;
        }

        .signup-page .benefit-item i {
            width: 38px;
            height: 38px;
            border-radius: 12px;
            font-size: 14px;
        }

        .signup-page .benefit-item strong {
            font-size: 14px;
        }

        .signup-page .benefit-item span {
            font-size: 12px;
        }
    }
    
    </style>
